const BreakPoints = {
    xs: 320,   // Extra small devices (mobile phones, 320px and up)
    sm: 600,   // Small devices (tablets, 600px and up)
    md: 900,   // Medium devices (small laptops, 900px and up)
    lg: 1140,  // Large devices (desktops, 1140px and up)
    xl: 1920,  // Extra large devices (large desktops, 1920px and up)
};

export default BreakPoints;
